{
  "MY_ACCOUNT": "Mitt konto",
  "END_USER": "Slutanvändare",
  "MFA_REQUIRED": "Mfa krävs",
  "Q_POPNR": "Pop. No",
  "SAVE_AND_DOWNLOAD_QUOTATION": "Spara & Ladda Ner",
  "PDF_IS_GENERATING": "PDF:en är under generering och kommer laddas ner så fort den är redo. Stäng inte ner fönstret under tiden.",
  "INCLUDED_ITEMS": "INCLUDED ITEMS",
  "SHOW_NEW_PRODUCTS": "Visa nya produkter",
  "SHOW_CAMPAIGN": "Visa kampanjer",
  "CART_ARTICLE_SKU_TOTAL": "{{article}} Artiklar",
  "TOTAL_AFTER_DISCOUNT": "Totalt efter rabatt: ",
  "TOTAL_BEFORE_DISCOUNT": "Totalt: ",
  "Annullerad": "Cancelled",
  "Fakturerad": "Invoiced",
  "Leverans påbörjad": "Delivery started",
  "Planerad": "Planned",
  "Registrerad": "Registered",
  "CATALOG_SELECTION": "Katalogval",
  "MARK_UP": "Mark Up (ytterligare procent)",
  "SHOW_CATALOG_SELECTION": "Car-O-Liner Repair Solutions Catalog",
  "CONFIRM_RESET": "Bekräftar du att återställa och har standarddata igen?",
  "RESET": "Återställa",
  "ADD_QUOTATION_ROW": "Lägg till offertrad",
  "ALLOWED_USERS": "Allowed users",
  "EXPIRE_DATE": "Utgångsdatum",
  "UPLOAD_CUSTOM_LOGO": "Ladda upp anpassad logotyp",
  "NAME_IS_REQUIRED": "Namn Krävs",
  "0_DISCOUNT": "0% rabatt ",
  "NEW_PRODUCTS": "Nya produkter",
  "PARTIAL_DELIVERY_EXPECTED": "Delvis leverans, första leveransen {{date}}",
  "ENTRY_IN_PROGRESS": "Inmatning pågår",
  "ENTERED": "Inmatad",
  "PICKING_IN_PROGRESS": "Plockning pågår",
  "INVOICED": "Fakturerad",
  "TOP_PRODUCTS": "Topp produkter",
  "NOT_ADD_BROCHURES": "I do not want brochures",
  "ADD_BROCHURES": "Add brochures",
  "BROCHURES_DECISION_NECESSARY": "Brochures decision necessary",
  "SPARE_PARTS": "Reservdelar",
  "TOTAL_VAT_INCLUDED": "Totalt inkl. moms: ",
  "VAT_PRECENTAGE": "Moms %",
  "VAT_VALUE": "Moms Värde: ",
  "SAVE_AND_EMAIL_QUOTATION": "Spara och skicka via e-post",
  "GST_PERCENTAGE": "GST %",
  "TO_BE_PHASED_OUT": "Fasas ut",
  "TARIFF_CODE": "Tullkod",
  "REPLACES_NUMBER": "Ersätter nummer",
  "REPLACES_PRODUCT": "Ersätter produkten",
  "NEWS_BANNER": "Nytt",
  "CAMPAIGN_UNTIL": "Kampanj till",
  "NEW_PRICE_FROM": "Nytt pris från",
  "PRESELECTED_CUSTOMER_ID": "Förvald kund-ID",
  "CHANGE_ACCOUNT": "Byt konto",
  "CONTACT_YOUR_SALES_REPRESENTATIVE": "Kontakta din säljare"
}
